import isReferralRibbon from '../assets/images/cassiopeia-badge-is-referral-ribbon.svg';
import isReferralIcon from '../assets/images/cassiopeia-badge-is-referral.svg';
import isReferralOutline from '../assets/images/cassiopeia-badge-is-referral-outline.svg';

import hasReferredRibbon from '../assets/images/cassiopeia-badge-has-referred-ribbon.svg';
import hasReferredIcon from '../assets/images/cassiopeia-badge-has-referred.svg';
import hasReferredOutline from '../assets/images/cassiopeia-badge-has-referred-outline.svg';

import ribbonAlt from '../assets/images/cassiopeia-badge-ribbon-alt.svg';
import whatsAppIcon from '../assets/images/cassiopeia-badge-whatsapp.svg';
import whatsAppOutline from '../assets/images/cassiopeia-badge-whatsapp-outline.svg';

import facebookIcon from '../assets/images/cassiopeia-badge-facebook.svg';
import facebookOutline from '../assets/images/cassiopeia-badge-facebook-outline.svg';

import emailIcon from '../assets/images/cassiopeia-badge-email.svg';
import emailOutline from '../assets/images/cassiopeia-badge-email-outline.svg';

/**
 * Grafiken der Errungenschaften, je Typ `{ ribbon, icon, outline }`.
 *
 * Ein Modul fuer beide Verbraucher: `<Badge assets={...} />` (Ribbon + Icon + Outline) und
 * `product.achievementBadges` fuer `AchievementsOverview` (Icon = erreicht, Outline = offen).
 * `ribbon` fehlt bei Facebook und E-Mail, weil diese Abzeichen kein Band haben.
 *
 * Die SVGs bleiben App-Assets: sie sind Markengrafiken dieser Kampagne, nicht des Kerns.
 */
export const achievementBadgeAssets = {
    isReferral: { ribbon: isReferralRibbon, icon: isReferralIcon, outline: isReferralOutline },
    hasReferred: { ribbon: hasReferredRibbon, icon: hasReferredIcon, outline: hasReferredOutline },
    whatsAppShares: { ribbon: ribbonAlt, icon: whatsAppIcon, outline: whatsAppOutline },
    facebookShares: { ribbon: null, icon: facebookIcon, outline: facebookOutline },
    emailShares: { ribbon: null, icon: emailIcon, outline: emailOutline },
};

export default achievementBadgeAssets;
